import React from "react";
import "./NewLoginForm.css";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";

export default function(props){
  return(
    <div className={'login-form'}>
      <div className="p-mb-4">
        <p className={'inputFieldLabel'}>Email</p>
        <InputText className={'inputField'} onChange={(e) => props.setEmail(e.target.value)}/>
      </div>
      <div>
        <p className={'inputFieldLabel'}>Password</p>
        <Password onChange={(e) => props.setPassword(e.target.value)} feedback={false} toggleMask/>
      </div>
    </div>
  )
}
